import React, { useState } from 'react'
import _ from 'lodash'
import ClipLoader from 'react-spinners/ClipLoader'
import { css } from '@emotion/core'

import { ReactComponent as Expand } from '../../assets/expand.svg'
import PaymentStream from './PaymentStream'

import './PaymentBuilder.css'

export default function PaymentSchedule({ paymentData, loading, inputData }) {
	const [expandStream, setExpandStream] = useState(false)
	const [expandPaymentDetails, setExpandPaymentDetails] = useState(false)
	const [toggle, setToggle] = useState(false)

	const override = css`
		background-color: #f5f7fa;
		margin: 0 auto;
		display: block;
	`

	function handleToggle() {
		setToggle(!toggle)
	}

	function handleExpandStream() {
		setExpandStream(true)
		setToggle(true)
	}

	function handleExpandAll() {
		setExpandStream(true)
		setExpandPaymentDetails(true)
	}

	function handleCollapseAll() {
		setExpandStream(false)
		setExpandPaymentDetails(false)
	}

	function calculateGrandTotal() {
		let total = 0
		paymentData.forEach((stream) => {
			stream.forEach((payment) => {
				total += payment.amount
			})
		})
		return total
	}

	let grandTotal = calculateGrandTotal()

	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	})

	return (
		<>
			<div className='payment-container'>
				<div className='banner'>
					<h3>Payment Schedule</h3>
				</div>
				<div className='content'>
					<div className='schedule-header'>
						<span onClick={() => handleToggle()} className='exp-coll'>
							{toggle ? (
								<span
									onClick={() => handleCollapseAll()}
									className='expand-collapse hover'
								>
									<Expand />
									<span className='padding-left hover'>Collapse All</span>
								</span>
							) : (
								<span
									className='expand-collapse hover'
									onClick={() => handleExpandAll()}
								>
									<Expand />
									<span className='padding-left hover'>Expand All</span>
								</span>
							)}
						</span>
						<h3>TOTAL PAYMENT</h3>
					</div>
					<div className='schedule-inner-content'>
						{loading ? (
							<div className='spinner'>
								<ClipLoader
									css={override}
									color={'#154B82'}
									loading={loading}
								/>
							</div>
						) : (
							paymentData.map((stream, index) => {
								let grouped = _.groupBy(stream, (payment) => payment.year)
								return (
									<PaymentStream
										expandPaymentDetails={expandPaymentDetails}
										expandStream={expandStream}
										handleExpandStream={handleExpandStream}
										grouped={grouped}
										id={index}
										key={index}
										inputData={inputData}
									/>
								)
							})
						)}
					</div>
					<div className='grand-total'>
						<div></div>
						<div>
							<span>Grand Total:</span>
							<span className='padding-left'>
								{formatter.format(grandTotal)}
							</span>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
